import { render, staticRenderFns } from "./ChatControls.vue?vue&type=template&id=8f8ee582&"
import script from "./ChatControls.vue?vue&type=script&lang=js&"
export * from "./ChatControls.vue?vue&type=script&lang=js&"
import style0 from "./ChatControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports